import {BaseFormModel} from './base-form-model';

export class DonationProgramSummary extends BaseFormModel<DonationProgramSummary> {
    id: number;
    donationCount: number;
    donationTotal: number;
    payoutCount: number;
    payoutTotal: number;
    balance: number;
}
